import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

/** Aligns the optional leading status glyph (e.g. the frozen snowflake) with its label. */
export const pillContent = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacing(1)};
`
